<template>
  <div class="container">
    <div class="row">


      <label class="control-label" v-if="this.getKey('tipo_dec') === 'Anual'">
        INGRESOS NETOS DEL DECLARANTE, PAREJA Y/O DEPENDIENTES ECONÓMICOS (ENTREL EL 1 DE ENERO Y EL 31 DE DICIEMBRE DEL AÑO INMEDIATO ANTERIOR)
      </label>

      <label class="control-label" v-if="this.getKey('tipo_dec') === 'Final'">
        INGRESOS NETOS DEL AÑO EN CURSO A LA FECHA DE CONCLUSIÓN DEL EMPLEO, CARGO O COMISIÓN DEL DECLARANTE, PAREJA Y/O DEPENDIENTES ECONÓMICOS
      </label>

      <label for="" class="control-label">Requisite cantidades libres de impuestos, <strong>SIN CENTAVOS Y SIN CEROS A LA IZQUIERDA.</strong></label>

    </div>

    <div class="row" v-if="this.getKey('tipo_dec') === 'Inicial'">
      <div class="form-group col-md-12">
        <label class="control-label">
          ¿TE DESEMPEÑASTE COMO SERVIDOR PÚBLICO OBLIGADO A PRESENTAR DECLARACIÓN DE SITUACIÓN PATRIMONIAL EN EL AÑO INMEDIATO ANTERIOR?
        </label>
        <p-radio class="d-inline-block" v-model="item_entes22.bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="item_entes22.bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="item_entes22.bandera == '1' || this.getKey('tipo_dec') === 'Anual' || this.getKey('tipo_dec') === 'Final'">
      <div class="row" v-if="this.getKey('tipo_dec') === 'Inicial'">
        <div class="form-group col-md-4">
          <label class="control-label">Inicio del periodo</label>
          <div class="form-group">
            <el-date-picker name="fecha_inicio_periodo" type="date" v-model="item_entes22.fecha_inicio_periodo" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha"></el-date-picker>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label class="control-label">Fin del periodo</label>
          <div class="form-group">
            <el-date-picker name="fecha_fin_periodo" type="date" v-model="item_entes22.fecha_fin_periodo" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha"></el-date-picker>
          </div>
        </div>
      </div>
      <!--
        <p>(Nota: si sus ingresos fueron en moneda extranjera, conviértalos a moneda nacional asentando en el apartado de observaciones y aclaraciones el tipo de cambio utilizado)</p>
        -->
      <div class="row">
        <p>I.Ingresos netos recibidos durante el tiempo en el que se desempeño como servidor público en el año inmediato anterior.</p>
        <div class="col-md-10 form-group" v-if="this.plantilla != null && this.getKey('tipo_dec') === 'Anual'">
          <label class="control-label">
            Te compartimos el <b>monto de tus ingresos</b> <strong> $ {{ this.plantilla.ingreso_anual_neto | formatPrice }} </strong>, proporcionado por el área de Recursos Humanos: si es correcta, registra la cantidad en el <b>punto I</b>, de existir error captura el monto correspondiente.</label>
        </div>
        <div class="col-md-10 form-group">
          <label class="control-label" v-if="this.getKey('tipo_dec') === 'Final'">
            I. Remuneración neta del año en curso a la fecha de conclusión del empleo, cargo o comisión del declarante por su cargo publico(por concepto de sueldos, honorarios, compensaciones, bonos, aguinaldos y otras prestaciones)(cantidades netas después de impuestos)
          </label>
          <label class="control-label" v-else>
            I. Remuneración neta del declarante, recibida durante el perdiodo que se desempeño como servidor público en el año inmediato anteior (por concepto de sueldos, honorarios, compensaciones, bonos, aguinaldos y otras prestaciones)(cantidades netas después de impuestos)
          </label>
        </div>
        <div class="col-md-2 form-group">
          <currency style="text-align: right" name="ant_sub_12" v-validate="'required|min:1|min_value:1'" v-model="item_entes22.ant_sub_12" sign="" aria-required="true" aria-invalid="true"></currency>
          <small class="text-danger">{{ errors.first('ant_sub_12') }}</small>
        </div>
        <p>II. Otros ingresos anuales netos del declarante (suma del II.1 al II.5).</p>
        <div class="col-md-12 form-group">
          <label class="control-label">
            II. 1 Por actividad industrial, comercial y/o comercial (Deduzca impuestos)
            Especifica nombre o razón social y tipo de negocio
          </label>
          <div class="row">
            <div class="col-md-4 form-group">
              <input class="form-control" type="text" v-model="item_entes22.ant_actividad_comercial" placeholder="Nombre o razón social">
            </div>
            <div class="col-md-4 form-group">
              <input class="form-control" type="text" v-model="item_entes22.tiponegocio" placeholder="Tipo de negocio">
            </div>
            <div class="col-md-4 form-group">
              <currency style="text-align: right" name="ant_actividad_comercial_cantidad" v-model="item_entes22.ant_actividad_comercial_cantidad" sign=""></currency>
              <small class="text-danger">{{ errors.first('ant_actividad_comercial_cantidad') }}</small>
            </div>
          </div>
        </div>
      </div>
      <!---->
      <div class="col-md-12 form-group">
        <label class="control-label">
          II. 2 Por actividad financiera (rendimientoso ganancias) (Después de impuestos)
        </label>
        <div class="row">
          <div class="col-md-8 form-group">
            Tipo de instrumento que generó el rendimiento o ganancia
            <el-select class="select-default" v-model="item_entes22.ant_actividad_financiera" width="100%" name="ant_actividad_financiera " clearable>
              <el-option v-for="option in tipo_instrumentos" class="select-default" :value="option.id" :label="option.valor" :key="option.id">
              </el-option>
            </el-select>
            <div v-if="item_entes22.ant_actividad_financiera == 7">
              <label class="control-label">
                Otro Sector
              </label>
              <input class="form-control" type="text" name="otroSector" v-model="item_entes22.otro_ant_actividad_financiera" placeholder="Otro tipo de instrumento" />
            </div>
          </div>
          <div class="col-md-4 form-group">
            <currency style="text-align: right" name="ant_actividad_financiera_cantidad" v-model="item_entes22.ant_actividad_financiera_cantidad" sign=""></currency>
            <small class="text-danger">{{ errors.first('ant_actividad_financiera_cantidad') }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
          II. 3 Por servicios profesionales, consejos, y/o asesorías Especifica el tipo de servicio y el contratante (Después de impuestos)
        </label>
        <div class="row">
          <div class="col-md-8 form-group">
            <input class="form-control" type="text" v-model="item_entes22.ant_servicios_profecionales" placeholder="Tipo de servicio prestado">
          </div>
          <div class="col-md-4 form-group">
            <currency style="text-align: right" name="ant_servicios_profecionales_cantidad" v-model="item_entes22.ant_servicios_profecionales_cantidad" sign=""></currency>
            <small class="text-danger">{{ errors.first('ant_servicios_profecionales_cantidad') }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
          II. 4 Por enajenación de bienes (Después de impuestos)
        </label>
        <div class="row">
          <div class="col-md-8 form-group">
            <el-select class="select-default" v-model="item_entes22.tipo_bien_enajenacion" width="100%" name="cat_tipo_bien_enajenacion" clearable>
              <el-option v-for="option in tipo_bien_enajenacion" class="select-default" :value="option.id" :label="option.valor" :key="option.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4 form-group">
            <currency style="text-align: right" name="ant_arrendamientos_cantidad" v-model="item_entes22.ant_arrendamientos_cantidad" sign=""></currency>
            <small class="text-danger">{{ errors.first('ant_arrendamientos_cantidad') }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
          II. 5 Otros ingresos no considerados a los anteriores (Después de impuestos)
        </label>
        <div class="row">
          <div class="col-md-8 form-group">
            <input class="form-control" type="text" v-model="item_entes22.otros_ingresos" placeholder="Descripción">
          </div>
          <div class="col-md-4 form-group">
            <currency style="text-align: right" name="ant_otros_cantidad" v-model="item_entes22.ant_otros_cantidad" sign=""></currency>
            <small class="text-danger">{{ errors.first('ant_otros_cantidad') }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
        </label>
        <div class="row">
          <div class="col-md-8 form-group" style="text-align: right">
            Subtotal:
          </div>
          <div class="col-md-4 form-group">
            <currency style="text-align: right" v-model="calculo1" sign="" readonly></currency>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
        </label>
        <div class="row">
          <div class="col-md-8 form-group" style="text-align: right">
            Suma Remuneración anual y Subtotal:
          </div>
          <div class="col-md-4 form-group">
            <currency style="text-align: right" name="ant_arrendamientos_cantidad" v-model="calculo2" sign="" readonly></currency>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
          A. INGRESO ANUAL NETO DEL DECLARANTE
        </label>
        <currency style="text-align: right" v-model="item_entes22.ant_suma_12" sign="" readonly></currency>
        <small class="text-danger">{{ errors.first('ant_neto_declarante') }}</small>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
          B. INGRESO ANUAL NETO DEL CÓNYUGE CONCUBINA O CONCUBINARIO Y/O DEPENDIENTES ECONÓMICOS (DEDUZCA IMPUESTOS)
          ESPECIFICA
        </label>
        <div class="row">
          <div class="col-md-8 form-group">
            <input class="form-control" type="text" v-model="item_entes22.ant_neto_conyugue" placeholder="Descripción">
          </div>
          <div class="col-md-4 form-group">
            <currency style="text-align: right" name="ant_neto_conyugue_cantidad" v-model="item_entes22.ant_neto_conyugue_cantidad" sign=""></currency>
            <small class="text-danger">{{ errors.first('ant_neto_conyugue_cantidad') }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
        </label>
        <div class="row">
          <div class="col-md-8 form-group" style="text-align: right">
            C. TOTAL DE INGRESOS ANUALES NETOS DEL DECLARANTE, CÓNYUGE, CONCUBINA O CONCUBINARIO
            Y/O DEPENDIENTES ECONÓMICOS:
          </div>
          <div class="col-md-4 form-group">
            <currency style="text-align: right" v-model="calculo3" sign="" readonly></currency>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Tag,
  Select,
  DatePicker,
  InputNumber
} from 'element-ui'
import {
  mapFields
} from 'vee-validate'
export default {
  components: {
    [Tag.name]: Tag,
    [DatePicker.name]: DatePicker,
    [InputNumber.name]: InputNumber

  },
  props: ['data'],
  data () {
    return {
      ip_id: null,
      add_item: false,
      tipo: '',
      tipoinst: [],
      tipobienen: [],
      suma3: 0,
      plantilla: {
        ingreso_anual_neto: ''
      },
      item_entes22: {
        ant_suma_12: 0,
        ant_actividad_comercial_cantidad: 0,
        ant_actividad_financiera_cantidad: 0,
        ant_servicios_profecionales_cantidad: 0,
        ant_arrendamientos_cantidad: 0,
        ant_ingreso_anual_cantidad: 0,
        ant_ingreso_anual_conyugue_cantidad: 0,
        ant_neto_conyugue_cantidad: 0,
        acciones: '',
        bandera: '0',
        rfc_quien_adquirio: '',
        ingreso_bruto_anual: '',
        moneda_id: 97,
        unidad_temporal_id: '',
        duracion_frecuencia: '',
        fecha_transaccion: '',
        pais_id: '',
        entidad_federativa_id: '',
        municipio_id: '',
        localidad_id: '',
        colonia: '',
        cp: '',
        numExt: '',
        numInt: '',
        vialidad_nom_vial: '',
        vialidad_tipo_vial: '',
        observaciones: ''
      }

    }
  },
  filters: {
    formatPrice: function (value) {
      let val = (value / 1).toFixed(0).replace('.', '.')

      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  computed: {
    ...mapFields(['ant_sub_12']),
    calculo1 () {
      var a = parseInt(this.item_entes22.ant_sub_12)
      var b = parseInt(this.item_entes22.ant_actividad_comercial_cantidad)
      var c = parseInt(this.item_entes22.ant_actividad_financiera_cantidad)
      var d = parseInt(this.item_entes22.ant_servicios_profecionales_cantidad)
      var e = parseInt(this.item_entes22.ant_arrendamientos_cantidad)
      var g = parseInt(this.item_entes22.ant_otros_cantidad)

      var suma = b + c + d + e + g

      if (isNaN(suma)) {
        return 0
      }
      return suma
    },
    calculo2 () {
      var a = parseInt(this.item_entes22.ant_sub_12)
      var b = parseInt(this.item_entes22.ant_actividad_comercial_cantidad)
      var c = parseInt(this.item_entes22.ant_actividad_financiera_cantidad)
      var d = parseInt(this.item_entes22.ant_servicios_profecionales_cantidad)
      var e = parseInt(this.item_entes22.ant_arrendamientos_cantidad)
      var g = parseInt(this.item_entes22.ant_otros_cantidad)

      var suma = a + b + c + d + e + g

      if (isNaN(suma)) {
        return 0
      }
      return suma
    },
    calculo3 () {
      var suma = 0

      var a = parseInt(this.item_entes22.ant_sub_12)
      if (isNaN(a)) {
        a = 0
      }
      var b = parseInt(this.item_entes22.ant_actividad_comercial_cantidad)
      if (isNaN(b)) {
        b = 0
      }
      var c = parseInt(this.item_entes22.ant_actividad_financiera_cantidad)
      if (isNaN(c)) {
        c = 0
      }
      var d = parseInt(this.item_entes22.ant_servicios_profecionales_cantidad)
      if (isNaN(d)) {
        d = 0
      }
      var e = parseInt(this.item_entes22.ant_arrendamientos_cantidad)
      if (isNaN(e)) {
        e = 0
      }
      var f = parseInt(this.item_entes22.ant_neto_conyugue_cantidad)
      if (isNaN(f)) {
        f = 0
      }
      var g = parseInt(this.item_entes22.ant_otros_cantidad)
      if (isNaN(g)) {
        g = 0
      }

      suma = a + b + c + d + e + f + g

      if (isNaN(suma)) {
        return 0
      }

      return suma
    }

  },
  watch: {
    'item_entes22.ant_sub_12': function () {
      this.calcula_totales2()
    },
    'item_entes22.ant_actividad_comercial_cantidad': function () {
      this.calcula_totales2()
    },
    'item_entes22.ant_actividad_financiera_cantidad': function () {
      this.calcula_totales2()
    },
    'item_entes22.ant_servicios_profecionales_cantidad': function () {
      this.calcula_totales2()
    },
    'item_entes22.ant_arrendamientos_cantidad': function () {
      this.calcula_totales2()
    },
    'item_entes22.ant_neto_declarante': function () {
      this.calcula_totales2()
    },
    'item_entes22.ant_neto_conyugue_cantidad': function () {
      this.calcula_totales2()
    }
  },
  methods: {

    calcula_totales2 (evt) {
      var sub12 = 0
      var sub22 = 0
      var unoydos2 = 0
      var segundasuma22 = 0

      sub12 = parseInt(this.item_entes22.ant_sub_12)
      sub22 = parseInt(this.item_entes22.ant_actividad_comercial_cantidad) + parseInt(this.item_entes22.ant_actividad_financiera_cantidad) + parseInt(this.item_entes22.ant_servicios_profecionales_cantidad) + parseInt(this.item_entes22.ant_arrendamientos_cantidad)
      unoydos2 = parseInt(sub12) + parseInt(sub22)
      this.item_entes22.ant_sub_22 = sub22
      this.item_entes22.ant_suma_12 = unoydos2
      this.suma3 = unoydos2

      segundasuma22 = parseInt(this.item_entes22.ant_neto_declarante) + parseInt(this.item_entes22.ant_neto_conyugue_cantidad)
      this.item_entes22.ant_suma_32 = segundasuma22
    },
    emptyFields (value) {
      if (value) {
        if (typeof value === 'string' || value instanceof String) {
          return value.toUpperCase()
        } else {
          return value
        }
      } else {
        return '-'
      }
    },

    // addItem55 () {
    //   if (this.item_entes22) {
    //     this.item_entes22.ip_id = this.ip_id
    //     this.loadButton(this.$refs.btnSave)
    //     this.$http.post('sueldos_otros', this.item_entes22).then(
    //       response => {
    //         this.StepOk('Guardado')
    //         if (this.edit_item === undefined || this.edit_item === null) {
    //           this.item_entes22 = response.data.sueldos
    //           // this.list_entes.push({
    //           // ...response.data.sueldo
    //           // });
    //         } else {
    //           this.list_entes.splice(
    //             this.edit_item.index,
    //             1,
    //             this.item_entes22
    //           )
    //           this.edit_item.item._rowVariant = ''
    //         }
    //         this.showItem()
    //         this.initItem()
    //         this.edit_item = null
    //       },
    //       error => {
    //         this.StepError(error)
    //       // this.change =  true;
    //       }
    //     )
    //   } else {
    //     this.StepW('Hay campos sin completar')
    //   }
    //   // console.log(this.item_entes22);
    // },

    validate () {
      return this.$validator.validateAll()
    }
  },
  created () {
    this.tipo = this.getKey('tipo_dec')
    this.ip_id = this.getId()

    this.$http.get('sueldos_otros/' + this.ip_id).then(
      response => {
        if (response.data.respuesta.sueldos != null) {
          this.item_entes22 = response.data.respuesta.sueldos
          this.plantilla = response.data.respuesta.plantilla

          if (Number(this.item_entes22.ant_sub_12) > 0) {
            this.item_entes22.bandera = '1'
          }
        }
      },
      error => {
        this.Err(error)
      }
    )
  },
  mounted () {
    this.checkCatalogs()
  }

}

</script>
<style>
.has-error .form-control,
.form-control.error,
.form-control[aria-invalid="true"] {
  color: #66615b !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Ingresos/SueldosSalariosOtros.vue